import React, { useEffect, useState } from 'react';
import './News.css';
import ScrollReveal from '../components/ScrollReveal';
import cardImg from '../assets/images/korean-blog/12-1.webp';
import langImg from '../assets/images/korean-blog/korean-language.webp';
import passportImg from '../assets/images/korean-blog/passport.webp';
import ppBImage from '../assets/images/korean-blog/pp-b-image.webp';
import ppBImage1 from '../assets/images/korean-blog/pp-b-image1.webp';
import ppBImage2 from '../assets/images/korean-blog/pp-b-image2.webp';
import ppBImage3 from '../assets/images/korean-blog/pp-b-image3.webp';
import koreanLangCardImg from '../assets/images/korean-blog/korean-language-image.webp';

export default function News() {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [activeTab, setActiveTab] = useState('sino');

  const openPopup = (article, defaultTab) => {
    setSelectedArticle(article);
    setActiveTab(defaultTab);
    document.body.style.overflow = 'hidden';
  };

  const closePopup = () => {
    setSelectedArticle(null);
    document.body.style.overflow = 'unset';
    if (window.location.search) {
      window.history.replaceState({}, '', '/news');
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const article = params.get('article');
    if (article === 'language') {
      openPopup('language', 'background');
    } else if (article === 'alphabet') {
      openPopup('alphabet', 'vowels');
    } else if (article === 'numbers') {
      openPopup('numbers', 'sino');
    } else if (article === 'passport') {
      openPopup('passport', 'passport_steps');
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="news-page" lang="si">
      <ScrollReveal>
        <section className="news-hero">
          <div className="news-hero-content">
            <h1>කොරියන් තතු</h1>
            <p>කොරියානු භාෂා ඉගෙනීමට සහ විභාගයට අත්‍යවශ්‍ය සියලුම විශේෂ කරුණු සහ නවතම තොරතුරු</p>
          </div>
        </section>
      </ScrollReveal>

      <div className="news-container">
        <ScrollReveal>
          <div className="news-cards-grid">
          <div className="news-main-card" onClick={() => openPopup('language', 'background')}>
            <div className="news-card-img-wrapper">
              <img src={koreanLangCardImg} alt="Korean Language" className="news-card-img" />
              <div className="news-card-badge">විශේෂ විස්තර</div>
            </div>
            <div className="news-card-details">
              <div className="news-card-meta">
                <span className="news-meta-category">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="meta-icon">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                  </svg>
                  භාෂා දැනුම
                </span>
                <span>•</span>
                <span>දැන් අලුතින්</span>
              </div>
              <h2 className="news-card-heading">කොරියානු භාෂාව</h2>
              <p className="news-card-snippet">
                කොරියානු ජාතිකයින් ලිවීමේදීත් කථා කිරීමේදිත් හාවිතා කරන්නේ එකම භාෂාවක් ය. එය ඔවුන්ගේ ජාතික අනන්යතාවය විදහාපාන විශිෂ්ට සාධකයන්ද වේ...
              </p>
              <div className="news-card-action">
                <span className="news-read-link">සම්පූර්ණ ලිපිය කියවන්න</span>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>
          </div>

          <div className="news-main-card" onClick={() => openPopup('numbers', 'sino')}>
            <div className="news-card-img-wrapper">
              <img src={cardImg} alt="Korean Numbers and Units" className="news-card-img" />
              <div className="news-card-badge">විශේෂ පාඩම්</div>
            </div>
            <div className="news-card-details">
              <div className="news-card-meta">
                <span className="news-meta-category">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="meta-icon">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                  </svg>
                  භාෂා දැනුම
                </span>
                <span>•</span>
                <span>දින 2කට පෙර</span>
              </div>
              <h2 className="news-card-heading">කොරියන් ගණිත ක්රම හා ඒකක ක්රම</h2>
              <p className="news-card-snippet">
                කොරියානුවන් ගණිත ක්රම 2ක් භාවිතා කරයි. චීන ගණිත ක්රමය සහ කොරියන් ගණිත ක්රමය පිළිබඳ සම්පූර්ණ විස්තරය මෙතැනින් කියවන්න.
              </p>
              <div className="news-card-action">
                <span className="news-read-link">සම්පූර්ණ ලිපිය කියවන්න</span>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>
          </div>

          <div className="news-main-card" onClick={() => openPopup('alphabet', 'vowels')}>
            <div className="news-card-img-wrapper">
              <img src={langImg} alt="Korean Alphabet" className="news-card-img" />
              <div className="news-card-badge">හෝඩිය</div>
            </div>
            <div className="news-card-details">
              <div className="news-card-meta">
                <span className="news-meta-category">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="meta-icon">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                  </svg>
                  භාෂා දැනුම
                </span>
                <span>•</span>
                <span>දැන් අලුතින්</span>
              </div>
              <h2 className="news-card-heading">කොරියානු අක්ෂර මාලාව</h2>
              <p className="news-card-snippet">
                කොරියානු හෝඩිය හන්ගල් ලෙස හදුන්වනු ලැබේ. ප්රධාන වශයෙන් කොරියානු භාෂාවේ අකුරු 40කි. මූලික ස්වර, ව්යංජන සහ හල් කිරීම් පිළිබඳව ඉගෙන ගන්න.
              </p>
              <div className="news-card-action">
                <span className="news-read-link">සම්පූර්ණ ලිපිය කියවන්න</span>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>
          </div>

          <div className="news-main-card" onClick={() => openPopup('passport', 'passport_steps')}>
            <div className="news-card-img-wrapper">
              <img src={passportImg} alt="Korean Passport Guide" className="news-card-img" />
              <div className="news-card-badge">විශේෂ විස්තර</div>
            </div>
            <div className="news-card-details">
              <div className="news-card-meta">
                <span className="news-meta-category">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="meta-icon">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                  </svg>
                  භාෂා දැනුම
                </span>
                <span>•</span>
                <span>දැන් අලුතින්</span>
              </div>
              <h2 className="news-card-heading">ගුවන් ගමන් බලපත්‍රය ලබාගැනීම</h2>
              <p className="news-card-snippet">
                ගුවන් ගමන් බලපත්රය යනු කොරියානු විභාගය සඳහා පෙනී සිටින ඔබට නැතිවම බැරි දෙයකි. මෙහිදී ගුවන් ගමන් බලපත්රයක් නිකුත් කිරීමේදී සලකා බලන කරුණු සහ අත්යවශ්යය තොරතුරු...
              </p>
              <div className="news-card-action">
                <span className="news-read-link">සම්පූර්ණ ලිපිය කියවන්න</span>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>
          </div>
          </div>
        </ScrollReveal>
      </div>

      {selectedArticle === 'numbers' && (
        <div className="news-modal-overlay" onClick={closePopup}>
          <div className="news-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="news-modal-close" onClick={closePopup}>&times;</button>
            
            <div className="news-modal-header">
              <div className="news-modal-tags">
                <span className="news-tag-category">භාෂා දැනුම</span>
                <span className="news-tag-date">May 06, 2026</span>
              </div>
              <h2>කොරියන් ගණිත ක්රම හා ඒකක ක්රම</h2>
              <p className="news-modal-subtitle">කොරියානුවන් ගණිත  ක්රම 2ක් භාවිතා කරයි.</p>
            </div>

            <div className="news-modal-tabs">
              <button 
                className={`tab-btn ${activeTab === 'sino' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('sino')}
              >
                චීන ගණිත ක්රමය
              </button>
              <button 
                className={`tab-btn ${activeTab === 'native' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('native')}
              >
                කොරියන් ගණිත ක්රමය
              </button>
              <button 
                className={`tab-btn ${activeTab === 'time' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('time')}
              >
                වේලාව ඇසීම සහ ප්රකාශ කිරීම
              </button>
            </div>

            <div className="news-modal-body">
              {activeTab === 'sino' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">චීන ගණිත ක්රමය</h3>
                  <p>චීන ගණන් සහ ඒකක ක්රමය චීන අක්ෂර මෙන්ම බොහෝ කාලයක සිට කොරියාවේදී භාවිතා කරන ලදී. දිනය, මාසය, සහ අවුරුද්ද දැක්වීම සදහාත් දුරකථන අංක, මාර්ග අංක, බස් අංක, නිවාස ගොඩනැගිලි, මහල් තට්ටු හැදින්වීමටත්, බර මණින විට kg ප්රකාශ කිරීම, වෙලාව දැක්වෙන විට මිනිත්තු ගණනය ප්රකාශ කිරීමත්, මුදල් ගණනය සදහාත් චීන ගණන් හා ඒකක ක්රම භාවිතාවේ.</p>

                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>සංඛ්‍යාව</th>
                          <th>කොරියානු අක්ෂර</th>
                          <th>උච්චාරණය</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>0</td><td className="kr-txt">영/공</td><td>යොං/කොං</td></tr>
                        <tr><td>1</td><td className="kr-txt">일</td><td>ඉල්</td></tr>
                        <tr><td>2</td><td className="kr-txt">이</td><td>ඊ</td></tr>
                        <tr><td>3</td><td className="kr-txt">삼</td><td>සම්</td></tr>
                        <tr><td>4</td><td className="kr-txt">사</td><td>සා</td></tr>
                        <tr><td>5</td><td className="kr-txt">오</td><td>ඕ</td></tr>
                        <tr><td>6</td><td className="kr-txt">육</td><td>යුක්</td></tr>
                        <tr><td>7</td><td className="kr-txt">칠</td><td>චිල්</td></tr>
                        <tr><td>8</td><td className="kr-txt">팔</td><td>පල්</td></tr>
                        <tr><td>9</td><td className="kr-txt">구</td><td>කු</td></tr>
                        <tr><td>10</td><td className="kr-txt">십</td><td>සිප්</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <p className="note-text">මෙතැන් සිට 19 දක්වා “සිප්” (දහය) යන්නට,</p>

                  <div className="formula-box-styled">
                    <div className="formula-line">10 + 1</div>
                    <div className="formula-line">십 + 일 ( සන්ධි වේ )</div>
                    <div className="formula-line">සිප් + ඉල්</div>
                    <div className="formula-line-result">එනම්...</div>
                    <div className="formula-line-result">11 - 십일 - සිබිල් යනුවෙන් උච්චාරණය වේ.</div>
                    <div className="formula-line-result">12 - 십이 - සිබි යනුවෙන් උච්චාරණය වේ .</div>
                    <div className="formula-line-result">13 - 십삼 - සිප් සම්</div>
                  </div>

                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>සංඛ්‍යාව</th>
                          <th>කොරියානු අක්ෂර</th>
                          <th>උච්චාරණය</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>20</td><td className="kr-txt">이십</td><td>ඊසිප්</td></tr>
                        <tr><td>30</td><td className="kr-txt">삼십</td><td>සම්සිප්</td></tr>
                        <tr><td>40</td><td className="kr-txt">사십</td><td>සාසිප්</td></tr>
                        <tr><td>50</td><td className="kr-txt">오십</td><td>ඕසිප්</td></tr>
                        <tr><td>60</td><td className="kr-txt">육십</td><td>යුක් සිප්</td></tr>
                        <tr><td>70</td><td className="kr-txt">칠십</td><td>චිල් සිප්</td></tr>
                        <tr><td>80</td><td className="kr-txt">팔십</td><td>ෆල්සිප්</td></tr>
                        <tr><td>90</td><td className="kr-txt">구십</td><td>කුසිප්</td></tr>
                        <tr><td>100</td><td className="kr-txt">백</td><td>පෙක්</td></tr>
                        <tr><td>1,000</td><td className="kr-txt">천</td><td>චොන්</td></tr>
                        <tr><td>10,000</td><td className="kr-txt">만</td><td>මාන්</td></tr>
                        <tr><td>100,000</td><td className="kr-txt">십만</td><td>සිප්මාන්</td></tr>
                        <tr><td>1000,000</td><td className="kr-txt">백만</td><td>පෙක්මාන්</td></tr>
                        <tr><td>10000,000</td><td className="kr-txt">천만</td><td>චොන්මාන්</td></tr>
                        <tr><td>100000,000</td><td className="kr-txt">억</td><td>ඔක්</td></tr>
                        <tr><td>1000000,000</td><td className="kr-txt">십억</td><td>සිබොක්</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <p>චීන ගණිත ක්රමය වෙලාවේ මිනිත්තු , දින , සති , මාස , වර්ෂ , තට්ටු නිවාසවල තට්ටු , මුදල් , ප්රශ්න අංක , මාර්ග අංක , දුරකථන අංක , වයස (ගෞරවාර්ථ ප්රකාශන ) ආදිය ගණනය කිරීම සඳහා යොදා ගනී.</p>

                  <div className="examples-section">
                    <div className="ex-block">
                      <h4>★ මිනිත්තු ප්රකාශ කිරීමේදී ( 분 )</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">오분 – ( ඕ බුන් ) - මිනිත්තු 5යි</p>
                      <p className="indent-line">이십분 - ( ඊසිප්පුන් ) - මිනිත්තු 20යි</p>
                      <p className="indent-line">사십오분 - ( සාසිප් ඕබুන් ) - මිනිත්තු 45යි</p>
                    </div>

                    <div className="ex-block">
                      <h4>★ දින ගණනය කිරීම හෝ ප්රකාශ කිරීමේදී ( 일 )</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">십일 전에 - ( සිබිල් ජොනේ ) - දින 10කට පෙර</p>
                      <p className="indent-line">이십일일 - ( ඊසිබිරිල් ) - 21වැනි දින</p>
                      <p className="indent-line">삼일 걸립니다 - ( සමිල් කොල්ලිම්නිදා ) - දින 3ක් ගතවෙනවා</p>
                    </div>

                    <div className="ex-block">
                      <h4>★ සති ගණනය කිරීමේදී ㈜</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">이주 전에 - ( ඊජු ජොනේ ) - සති 2කට පෙර</p>
                      <p className="indent-line">일주 걸렸습니다 - ( ඉල්ජු කොල්යොස්සම්නිදා ) - සතියක් ගත වුණා</p>
                    </div>

                    <div className="ex-block">
                      <h4>★ අවුරුද්දේ මාස 12 ප්රකාශ කිරීම( 월 ) සහ මාස ගණන් කිරීමේදී ( 개월 )</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">일월 - (ඉර්වොල්) - ජනවාරි මාසය</p>
                      <p className="indent-line">팔월 - (පර්වොල්) - අගෝස්තු මාසය</p>
                      <p className="indent-line">삼개월 배웠습니다 - ( සම්ගෙවොල් පෙවොස්සම්නිදා ) - මාස 3ක් ඉගෙන ගත්තා</p>
                      <p className="indent-line">육개월 일했습니다 - ( 육개월 일했습니다 ) - මාස 6ක් වැඩ කරා</p>
                    </div>

                    <div className="ex-block">
                      <h4>★ වර්ෂය ප්රකාශ කිරීම සහ වර්ෂ ගණනය කිරීමේදී (년)</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">천구백팔십칠년 - ( චොන්ගුබෙක්පල්සිප්චිල්න්යොන් ) - 1987 වර්ෂය</p>
                      <p className="indent-line">이천십팔년에 한국에 왔습니다 - ( ඊ천십팔년에 한국에 왔습니다 ) - 2018 වර්ෂයේ කොරියාවට අවේ</p>
                      <p className="indent-line">이년 일했습니다 - ( 이년 일했습니다 ) - වසර 2ක් වැඩ කළා</p>
                      <p className="indent-line">이년 배웠습니다 - ( 이년 배웠습니다 ) - වසරක් ඉගෙන ගත්තා</p>
                    </div>

                    <div className="ex-block">
                      <h4>★ මහල් නිවාසවල තට්ටු ගණනය කිරීමේදී (층)</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">오층에 있습니다 - ( 오층에 있습니다 ) - 5වෙනි තට්ටුවේ ඉන්නවා</p>
                      <p className="indent-line">십층이 있습니다 - ( 십층이 있습니다 ) - තට්ටු 10ක් තියෙනවා</p>
                    </div>

                    <div className="ex-block">
                      <h4>★ මුදල් ගණනය කිරීමේදී (원)</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">사과가 천오백원 입니다 - ( 사과가 천오백원 입니다 ) – ඇපල් වොන් 1500යි</p>
                      <p className="indent-line">휴대전화가 이십만원 입니다 - ( 휴대전화가 이십만원 입니다 ) - ජංගම දුරකථනය වොන් 200000යි</p>
                    </div>

                    <div className="ex-block">
                      <h4>★ මාර්ග අංක , බස් අංක , ප්රශ්න අංක , දුරකථන අංක ගණනය කිරීමේදී (번)</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">이번 도로 - (이번 도로) - 2වෙනි මාර්ගය</p>
                      <p className="indent-line">백구번 버스를 타십시오 - (백구번 버스를 타십시오) - අංක 109 වෙනි බසයට නගින්න</p>
                      <p className="indent-line">십오번 문제를 읽으십시오 - (십오번 문제를 읽으십시오) - 15වෙනි ප්රශ්න අංකය කියවන්න</p>
                      <p className="indent-line">제 전화 번호는 공일공에 이삼사에 일이삼사번 입니다 - ( 제 전화 번호는 공일공에 이삼사에 일이삼사번 입니다 ) - මගේ දුරකථන අංකය 010 – 234 -1234 වේ.</p>
                    </div>

                    <div className="ex-block">
                      <h4>★ වයස ප්රකාශ කිරීමේදී ( ගෞරවාර්ථ ප්රකාශන ) ( 세 )</h4>
                      <p>උදා:-</p>
                      <p className="indent-line">제 아버지 연세가 오십삼세 입니다. - ( 제 아버지 연세가 오십삼세 입니다. ) - මගේ තාත්තාගේ වයස අවු. 53කි.</p>
                      <p className="indent-line">우리 어머니 연세는 사십팔세 입니다. - ( 우리 어머니 연세는 사십팔세 입니다. ) - අපේ අම්මාගේ වයස අවු. 48 කි.</p>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'native' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">කොරියන් ගණිත ක්රමය</h3>
                  <p>සියළුම ද්රව්ය, පුද්ගලයන් , සතුන් ,වයස (සාමාන්ය ප්රකාශන), පැය ගණන් ගණනය කිරීමේ දී කොරියානු ගණිත ක්රමය භාවිතා වේ.</p>

                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>සංඛ්‍යාව</th>
                          <th>කොරියානු අක්ෂර</th>
                          <th>උච්චාරණය</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>0)</td><td className="kr-txt">공 / 영</td><td>කොං / යොං</td></tr>
                        <tr><td>1)</td><td className="kr-txt">하나 / 한</td><td>හනා / හන් (ඒකක නාමයක් සමග යෙදෙන විට )</td></tr>
                        <tr><td>2)</td><td className="kr-txt">둘 / 두</td><td>තුල් / තූ (ඒකක නාමයක් සමග යෙදෙන විට )</td></tr>
                        <tr><td>3)</td><td className="kr-txt">셋 / 세</td><td>සෙත් / සේ (ඒකක නාමයක් සමග යෙදෙන විට )</td></tr>
                        <tr><td>4)</td><td className="kr-txt">넷 / 네</td><td>නෙත් / නේ (ඒකක නාමයක් සමග යෙදෙන විට )</td></tr>
                        <tr><td>5)</td><td className="kr-txt">다섯</td><td>තසොත්</td></tr>
                        <tr><td>6)</td><td className="kr-txt">여섯</td><td>යොසොත්</td></tr>
                        <tr><td>7)</td><td className="kr-txt">일곱</td><td>ඉල්ගොප්</td></tr>
                        <tr><td>8)</td><td className="kr-txt">여덟</td><td>යොදොල්</td></tr>
                        <tr><td>9)</td><td className="kr-txt">아홉</td><td>අහොප්</td></tr>
                        <tr><td>10)</td><td className="kr-txt">열</td><td>යොල්</td></tr>
                        <tr><td>11)</td><td className="kr-txt">열하나</td><td>යොල්හනා</td></tr>
                        <tr><td>20)</td><td className="kr-txt">스물 / 스무</td><td>සමුල්</td></tr>
                        <tr><td>30)</td><td className="kr-txt">서른</td><td>සොරන්</td></tr>
                        <tr><td>40)</td><td className="kr-txt">마흔</td><td>මාහන්</td></tr>
                        <tr><td>50)</td><td className="kr-txt">쉰</td><td>ස්වින්</td></tr>
                        <tr><td>60)</td><td className="kr-txt">예순</td><td>යේසුන්</td></tr>
                        <tr><td>70)</td><td className="kr-txt">일흔</td><td>ඉල්හන් (ඉරන්)</td></tr>
                        <tr><td>80)</td><td className="kr-txt">여든</td><td>යොදන්</td></tr>
                        <tr><td>90)</td><td className="kr-txt">아흔</td><td>ආහන්</td></tr>
                        <tr><td>100)</td><td className="kr-txt">백</td><td>පෙක්</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <p>කොරියානු බසින් යම් දෙයක් ගණන් කිරීමේදී ,</p>
                  <div className="step-block">
                    <p className="step-item">ද්රව්යයේ නම</p>
                    <p className="step-item">සංඛ්යාව</p>
                    <p className="step-item">ද්රව්යයට භාවිතා කරන විශේෂ නම හෙවත් ඒකක නාමය පිළිවෙලින් පැවසිය යුතුවේ.</p>
                  </div>

                  <p>උදා:-</p>
                  <div className="table-responsive">
                    <table className="korean-table text-left">
                      <thead>
                        <tr>
                          <th>ද්‍රව්‍යය</th>
                          <th>කොරියානු</th>
                          <th>ඒකක නාමය</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>වයස</td><td className="kr-txt">나이</td><td>(살)</td></tr>
                        <tr><td>වෙලාව</td><td className="kr-txt">시간</td><td>(시)</td></tr>
                        <tr><td>කාලය</td><td className="kr-txt">시간</td><td>(시간) (පැය ගණන් )</td></tr>
                        <tr><td>මිනිසුන්</td><td className="kr-txt">사람</td><td>(명 / 분)</td></tr>
                        <tr><td>සතුන්</td><td className="kr-txt">동물</td><td>(마리)</td></tr>
                        <tr><td>යන්ත්ර</td><td className="kr-txt">기게</td><td>(대)</td></tr>
                        <tr><td>කඩදාසි</td><td className="kr-txt">총이</td><td>(장)</td></tr>
                        <tr><td>කෝප්ප</td><td className="kr-txt">잔</td><td>(잔)</td></tr>
                        <tr><td>බෝතල්</td><td className="kr-txt">병</td><td>(병)</td></tr>
                        <tr><td>පෑන්/පැන්සල්</td><td className="kr-txt">볼펜/연필</td><td>(자루)</td></tr>
                        <tr><td>සපත්තු</td><td className="kr-txt">구두</td><td>(결레)</td></tr>
                        <tr><td>ඇදුම්</td><td className="kr-txt">옷</td><td>(벌)</td></tr>
                        <tr><td>ගස්</td><td className="kr-txt">나무</td><td>(가루)</td></tr>
                        <tr><td>පැකට්</td><td className="kr-txt">답배</td><td>(갑)</td></tr>
                        <tr><td>දීසි</td><td className="kr-txt">밥</td><td>(그릇)</td></tr>
                        <tr><td>ගෙවල්</td><td className="kr-txt">집</td><td>(채)</td></tr>
                        <tr><td>මල්/මිදී /කෙසෙල්</td><td className="kr-txt">꽃 /포도/바나나</td><td>(송이)</td></tr>
                        <tr><td>බෝට්ටු</td><td className="kr-txt">배</td><td>(적)</td></tr>
                        <tr><td>ගොඩනැගිලි</td><td className="kr-txt">건물</td><td>(동)</td></tr>
                        <tr><td>දේවල්</td><td className="kr-txt">사물</td><td>(개)</td></tr>
                        <tr><td>පොත්</td><td className="kr-txt">첵</td><td>(권)</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <p>මෙවැනි ගැටළු නිරාකරණය කර පහසුවෙන් ම ලකුණු ලබාගත හැකිය.</p>
                  <p>අපි දැන් පොඩි සමීකරණයකට අවධානය යොමු කරමු.</p>
                  <div className="equation">[[නාම පදය + ඉලක්කම + ඒකකය + ක්රීයාපදය]]</div>
                  <p>උදාහරණ ලෙස:-</p>

                  <div className="equation-box">
                    <p>✸ ඔබ සිතන්න ඔබට මහල් ගොඩනැගිලි 6ක් සහිත පින්තූරයක් ලැබී ඇත. එය පහත සමීකරණට අනුව ගොඩනගමු .</p>
                    <div className="sub-eq">[[නාමපදය + ඉලක්කම + ඒකකය + ක්රීයාපදය]]</div>
                    <div className="kr-src">아바트가 + 여섯 + 동 + 있습니다</div>
                    <div className="kr-src">아바트가 여섯 동 있습니다</div>
                  </div>

                  <div className="equation-box">
                    <p>✸ මිනිසුන් දෙදෙනෙකු යනවා</p>
                    <div className="sub-eq">[[නාමපදය + ඉලක්කම + ඒකකය + ක්රීයාපදය]]</div>
                    <div className="kr-src">사람이 +두 + 명 + 갑니다</div>
                    <div className="kr-src">사람이 두 명 갑니다</div>
                  </div>

                  <div className="equation-box">
                    <p>✸ වතුර වීදුරුවක් දෙන්න.</p>
                    <div className="sub-eq">[[නාමපදය + ඉලක්කම + ඒකකය + ක්රීයාපදය]]</div>
                    <div className="kr-src">물 + 한 + 잔 + 주세요.</div>
                    <div className="kr-src">물 한잔 주세요.</div>
                    <p>( මෙය පාඩම් කිරීම ඉතා වැදගත් වේ. විභාගයට ඉලක්ක පාඩමකි .)</p>
                  </div>
                </div>
              )}

              {activeTab === 'time' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">කොරියානු භාෂාවෙන් වේලාව ඇසීම සහ ප්රකාශ කිරීම</h3>

                  <div className="time-split-grid">
                    <div className="time-column">
                      <h4>පැය (시) සි</h4>
                      <table className="korean-table slim">
                        <tbody>
                          <tr><td>01:00</td><td className="kr-txt">1시</td><td>한 시</td></tr>
                          <tr><td>02:00</td><td className="kr-txt">2시</td><td>두 시</td></tr>
                          <tr><td>03:00</td><td className="kr-txt">3시</td><td>세 시</td></tr>
                          <tr><td>04:00</td><td className="kr-txt">4시</td><td>네 시</td></tr>
                          <tr><td>05:00</td><td className="kr-txt">5시</td><td>다섯 시</td></tr>
                          <tr><td>06:00</td><td className="kr-txt">6시</td><td>여섯 시</td></tr>
                          <tr><td>07:00</td><td className="kr-txt">7시</td><td>일곱 시</td></tr>
                          <tr><td>08:00</td><td className="kr-txt">8시</td><td>여덟 시</td></tr>
                          <tr><td>09:00</td><td className="kr-txt">9시</td><td>아홉 시</td></tr>
                          <tr><td>10:00</td><td className="kr-txt">10시</td><td>열 시</td></tr>
                          <tr><td>11:00</td><td className="kr-txt">11시</td><td>열한 시</td></tr>
                          <tr><td>12:00</td><td className="kr-txt">12시</td><td>열두 시</td></tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="time-column">
                      <h4>විනාඩි (분)</h4>
                      <table className="korean-table slim">
                        <tbody>
                          <tr><td>00:01</td><td className="kr-txt">1분</td><td>일 분</td></tr>
                          <tr><td>00:02</td><td className="kr-txt">2분</td><td>이 분</td></tr>
                          <tr><td>00:03</td><td className="kr-txt">3분</td><td>삼 분</td></tr>
                          <tr><td>00:04</td><td className="kr-txt">4분</td><td>사 분</td></tr>
                          <tr><td>00:05</td><td className="kr-txt">5분</td><td>오 분</td></tr>
                          <tr><td>00:06</td><td className="kr-txt">6분</td><td>육 분</td></tr>
                          <tr><td>00:07</td><td className="kr-txt">7분</td><td>칠 분</td></tr>
                          <tr><td>00:08</td><td className="kr-txt">8분</td><td>팔 분</td></tr>
                          <tr><td>00:09</td><td className="kr-txt">9분</td><td>구 분</td></tr>
                          <tr><td>00:10</td><td className="kr-txt">10분</td><td>십 분</td></tr>
                          <tr><td>00:20</td><td className="kr-txt">20분</td><td>이십 분</td></tr>
                          <tr><td>00:30</td><td className="kr-txt">30분</td><td>삼십 분</td></tr>
                          <tr><td>00:40</td><td className="kr-txt">40분</td><td>사십 분</td></tr>
                          <tr><td>00:50</td><td className="kr-txt">50분</td><td>오십 분</td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <p>පළමුව අපි කාලය හා සම්බන්ධ ප්රශ්න විමසන සහ ප්රකාශන සිදු කරන ආකාරය පිළිබඳව අධ්යයනය කරමු.</p>

                  <div className="vocab-grid">
                    <div className="vocab-item"><span>일 / 날</span> <span>ඉල් / නල් - දිනය</span></div>
                    <div className="vocab-item"><span>오늘</span> <span>ඔනල් - අද</span></div>
                    <div className="vocab-item"><span>어제</span> <span>ඔජේ - ඊයෙ</span></div>
                    <div className="vocab-item"><span>내일</span> <span>නෙඉල් - හෙට</span></div>
                    <div className="vocab-item"><span>그저께</span> <span>කජොක්කෙ - පෙරේදා</span></div>
                    <div className="vocab-item"><span>모레</span> <span>මොරේ - අනිද්දා</span></div>
                    <div className="vocab-item"><span>년</span> <span>න්යොන් - අවුරුද්ද</span></div>
                    <div className="vocab-item"><span>내년</span> <span>නෙන්යොන් - ලබන අවුරුද්ද</span></div>
                    <div className="vocab-item"><span>내후년</span> <span>නෙහුන්යොන් - ලබන වසරට පසු අවුරුද්ද</span></div>
                    <div className="vocab-item"><span>작년</span> <span>작년 - ගිය වසර</span></div>
                    <div className="vocab-item"><span>재작년</span> <span>재작년 - ගිය වසරට පෙර වසර</span></div>
                    <div className="vocab-item"><span>주</span> <span>주 - සතිය</span></div>
                    <div className="vocab-item"><span>주말</span> <span>주말 - සති අන්තය</span></div>
                    <div className="vocab-item"><span>달 / 월</span> <span>달 / 월 - මාසය</span></div>
                    <div className="vocab-item"><span>지금</span> <span>지금 - දැන්</span></div>
                    <div className="vocab-item"><span>새벽</span> <span>새벽 - හිමිදිරිය /පාන්දර</span></div>
                    <div className="vocab-item"><span>오전</span> <span>오전 - පෙ.ව. AM</span></div>
                    <div className="vocab-item"><span>오후</span> <span>오후 - ප.ව. PM</span></div>
                    <div className="vocab-item"><span>낮</span> <span>낮 - දවල්</span></div>
                    <div className="vocab-item"><span>밤</span> <span>밤 - රාත්රිය</span></div>
                    <div className="vocab-item"><span>아침</span> <span>아침 - උදෑසන</span></div>
                    <div className="vocab-item"><span>점심</span> <span>점심 - දහවල</span></div>
                    <div className="vocab-item"><span>저녁</span> <span>저녁 - සන්ධ්යාව</span></div>
                    <div className="vocab-item"><span>몇</span> <span>몇 - කුමණ/ කීයද (වේලාව  සම්බන්ධ ව                          භාවිතා    කරයි )</span></div>
                  </div>

                  <p>වේලාව නැතහොත් 시간 යන්න ප්රකාශ කිරීමකදී 시(සි) යන ඒකකය පැය දැක්වීමටද 분 ( බුන් ) විනාඩි දැක්වීමටද භාවිතා කරයි ( පෙර සදහන් කළ පරිදි )</p>

                  <div className="phrase-box-styled">
                    <p>පස්වරු 5:30 යි.</p>
                    <p className="kr-bold">오후 다섯시 삼십분 입니다.</p>
                  </div>

                  <p>වෙලාව හා සම්බන්ධ වාක්ය</p>
                  <div className="phrase-box-styled">
                    <p>දැන් වෙලාව කීයද? - 지금 몇 시예요?</p>
                    <p>දැන් වෙලාව 10 යි. - 지금 10 시예요.</p>
                    <p>දවල් කෑම කන්නෙ කුමණ වෙලාවටද?</p>
                    <p className="kr-bold">점심을 몇 시에 먹어요?.</p>
                    <p>12: 30 ට කන්නෙ</p>
                    <p className="kr-bold">열두시 삼십분에 먹어요.</p>
                  </div>

                  <h3 className="section-subheading">주중 - සතියේ දවස්</h3>
                  <div className="days-grid">
                    <div className="day-card"><strong>일요일</strong><span>( ඉර්යෝඉල් ) - ඉරිදා</span></div>
                    <div className="day-card"><strong>월요일</strong><span>( වොර්යෝඉල් ) - සදුදා</span></div>
                    <div className="day-card"><strong>화요일</strong><span>( හ්වයෝඉල් ) - අඟහරුවදා</span></div>
                    <div className="day-card"><strong>수요일</strong><span>( සුයෝඉල් ) - බදාදා</span></div>
                    <div className="day-card"><strong>목요일</strong><span>( මොග්යෝඉල් ) - බ්රහස්පතින්දා</span></div>
                    <div className="day-card"><strong>금요일</strong><span>( කම්යෝඉල් ) - සිකුරාදා</span></div>
                    <div className="day-card"><strong>토요일</strong><span>( තොයෝඉල් ) - සෙනසුරාදා</span></div>
                  </div>

                  <h3 className="section-subheading">월 - මාස</h3>
                  <div className="months-grid">
                    <div className="month-card"><strong>일월</strong><span>( ඉර්වොල් ) - ජනවාරි</span></div>
                    <div className="month-card"><strong>이월</strong><span>( ඊවොල් ) - පෙබරවාරි</span></div>
                    <div className="month-card"><strong>삼월</strong><span>( සම්වොල් ) - මාර්තූ</span></div>
                    <div className="month-card"><strong>사월</strong><span>( සාවොල් ) - අප්රේල්</span></div>
                    <div className="month-card"><strong>오월</strong><span>( ඕවොල් ) - මැයි</span></div>
                    <div className="month-card"><strong>유월</strong><span>( යුවොල් ) - ජුනි</span></div>
                    <div className="month-card"><strong>칠월</strong><span>( චිර්වොල් ) - ජූලි</span></div>
                    <div className="month-card"><strong>팔월</strong><span>( ඵර්වොල් ) - අගෝස්තු</span></div>
                    <div className="month-card"><strong>구월</strong><span>( කුවොල් ) - සැත්තැම්බර්</span></div>
                    <div className="month-card"><strong>시월</strong><span>( සිවොල් ) - ඔක්තෝබර්</span></div>
                    <div className="month-card"><strong>십일월</strong><span>( සිබිර්වොල් ) - නොවැම්බර්</span></div>
                    <div className="month-card"><strong>십이월</strong><span>(සිබීවොල්) - දෙසැම්බර්</span></div>
                  </div>
                </div>
              )}
            </div>

            <div className="news-modal-footer">
              <button className="news-modal-btn" onClick={closePopup}>වසා දමන්න</button>
            </div>
          </div>
        </div>
      )}

      {selectedArticle === 'alphabet' && (
        <div className="news-modal-overlay" onClick={closePopup}>
          <div className="news-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="news-modal-close" onClick={closePopup}>&times;</button>
            
            <div className="news-modal-header">
              <div className="news-modal-tags">
                <span className="news-tag-category">භාෂා දැනුම</span>
                <span className="news-tag-date">May 06, 2026</span>
              </div>
              <h2>කොරියානු අක්ෂර මාලාව</h2>
              <p className="news-modal-subtitle">කොරියානු භාෂාව හන්ගුක් මල් හෙවත් හන්ගුගෝ  ලෙස හඳුන්වයි. ඒ වගේම කොරියානු හෝඩිය හන්ගල් ලෙස හදුන්වනු ලැබේ.</p>
            </div>

            <div className="news-modal-tabs">
              <button 
                className={`tab-btn ${activeTab === 'vowels' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('vowels')}
              >
                ස්වර සහ ව්යංජන
              </button>
              <button 
                className={`tab-btn ${activeTab === 'structures' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('structures')}
              >
                අක්ෂර භාවිතය
              </button>
              <button 
                className={`tab-btn ${activeTab === 'pronunciation' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('pronunciation')}
              >
                උච්චාරණ නීති
              </button>
            </div>

            <div className="news-modal-body">
              {activeTab === 'vowels' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">කොරියානු අක්ෂර මාලාව</h3>
                  <p>කොරියානු භාෂාව හන්ගුක් මල් හෙවත් හන්ගුගෝ ලෙස හඳුන්වයි. ඒ වගේම කොරියානු හෝඩිය හන්ගල් ලෙස හදුන්වනු ලැබේ. ප්රධාන වශයෙන් කොරියානු භාෂාවේ අකුරු 40කි. එය මුලීක වශයෙන් කොටස් 2 කින් යුක්ත වන අතර ඒවා හන්ගල් යනුවෙන් හදුන්වයි.</p>
                  
                  <div className="formula-box-styled">
                    <div className="formula-line">ස්වර - 21</div>
                    <div className="formula-line">ව්යංජන - 19</div>
                  </div>

                  <h3 className="section-subheading">ස්වර</h3>
                  <p>කොරියානු භාෂාව තුළ ස්වර කොටස් දෙකකි. ඒවානම් :-</p>
                  <div className="formula-box-styled">
                    <div className="formula-line">මුලීක ස්වර - 10</div>
                    <div className="formula-line">සංයුක්ත ස්වර - 11</div>
                  </div>

                  <h3 className="section-subheading">කොරියානු හෝඩිය (한글)</h3>
                  <p>දැන් අපි මෙහි තිබෙන ස්වර හදුනා ගනිමු.</p>
                  <p>ස්වර ලියනු ලබන්නේ ඉහළ සිට පහළටත් වමේ සිට දකුණටත් වන අතර ස්වරයක් තනිවම උච්චාරණය කළ හැකි නමුත් තනිව ලිවිය නොහැක. ඒ සඳහා "ㅇ"ව්යංජන අක්ෂරය යොදාගනු ලැබේ. එම "ㅇ"අක්ෂරය එකතු කිරීමේ දී. සිරස් අතට ලියන ලද ස්වරයක් නම් “o“ අක්ෂරය ලියා ඉදිරියෙන් අදාළ ස්වරය ලියන අතර තිරස් අතට ලියන ලද ස්වරයක් නම් “o” අක්ෂරය ලියා එයට පහළින් අදාළ ස්වරය ලියනු ලැබේ.</p>
                  
                  <div className="formula-box-styled">
                    <div className="formula-line">✭ මෙසේ “o” ව්යංජන අක්ෂරය යෙදෙන්නේ ස්වරය අක්ෂරයක් ලෙස වචනයක යෙදෙන අවස්ථාවේදී ය.</div>
                  </div>

                  <div className="equation-box">
                    <p>සිරස් ස්වර = ㅏ.야.어.여.이 (ㅏ.ㅑ.ㅓ.ㅕ.ㅣ)</p>
                    <p>ලියන ආකාරය = 아. 야. 어. 여. 이</p>
                  </div>

                  <div className="equation-box">
                    <p>තිරස් ස්වර = ㅗ. 요. 우. 유. 으 (ㅗ. ㅛ. ㅜ. ㅠ .ㅡ)</p>
                    <p>ලියන ආකාරය = 오. 요. 우. 유. 으</p>
                  </div>

                  <h3 className="section-subheading">මුලික ස්වර</h3>
                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>කොරියානු අක්ෂර</th>
                          <th>සිංහල උච්චාරණය</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td className="kr-txt">아</td><td>ආ</td></tr>
                        <tr><td className="kr-txt">야</td><td>යා</td></tr>
                        <tr><td className="kr-txt">어</td><td>ඔ</td></tr>
                        <tr><td className="kr-txt">여</td><td>යො</td></tr>
                        <tr><td className="kr-txt">오</td><td>ඕ</td></tr>
                        <tr><td className="kr-txt">요</td><td>යෝ</td></tr>
                        <tr><td className="kr-txt">우</td><td>උ</td></tr>
                        <tr><td className="kr-txt">유</td><td>යු</td></tr>
                        <tr><td className="kr-txt">으</td><td>සංවෘත අ</td></tr>
                        <tr><td className="kr-txt">이</td><td>ඉ</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <h3 className="section-subheading">සංයුක්ත ස්වර</h3>
                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>කොරියානු අක්ෂර</th>
                          <th>සිංහල උච්චාරණය</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td className="kr-txt">ㅐ</td><td>එ</td></tr>
                        <tr><td className="kr-txt">ㅒ</td><td>යෙ</td></tr>
                        <tr><td className="kr-txt">ㅔ</td><td>ඒ</td></tr>
                        <tr><td className="kr-txt">ㅖ</td><td>යේ</td></tr>
                        <tr><td className="kr-txt">ㅘ</td><td>වා</td></tr>
                        <tr><td className="kr-txt">ㅙ</td><td>වේ</td></tr>
                        <tr><td className="kr-txt">ㅚ</td><td>වෙ</td></tr>
                        <tr><td className="kr-txt">ㅝ</td><td>වො</td></tr>
                        <tr><td className="kr-txt">ㅞ</td><td>වෙ</td></tr>
                        <tr><td className="kr-txt">ㅟ</td><td>වී</td></tr>
                        <tr><td className="kr-txt">ㅢ</td><td>අඉ</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <p>මූලික ස්වර දෙකක් හෝ කිහිපයක් එකතු වී සෑදෙන ස්වර මෙලෙස හඳුන්වයි.සංයුක්ත ස්වර වචනයක යෙදීමේදී ද මූලික ස්වර ලියන අයුරින්ම “o”ව්යංජන අක්ෂරය ලියා පහත පරිදි ලියනු ලැබේ.</p>
                  
                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>කොරියානු අක්ෂර</th>
                          <th>සිංහල උච්චාරණය</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td className="kr-txt">애</td><td>එ</td></tr>
                        <tr><td className="kr-txt">얘</td><td>යෙ</td></tr>
                        <tr><td className="kr-txt">에</td><td>ඒ</td></tr>
                        <tr><td className="kr-txt">예</td><td>යේ</td></tr>
                        <tr><td className="kr-txt">와</td><td>වා</td></tr>
                        <tr><td className="kr-txt">왜</td><td>වේ</td></tr>
                        <tr><td className="kr-txt">외</td><td>වෙ</td></tr>
                        <tr><td className="kr-txt">워</td><td>වො</td></tr>
                        <tr><td className="kr-txt">웨</td><td>වෙ</td></tr>
                        <tr><td className="kr-txt">위</td><td>වි</td></tr>
                        <tr><td className="kr-txt">의</td><td>අඉ</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <p>අපි දැන් ස්වර ඉගෙන ගත් නිසා වචන ටිකක් කියවන්න බලමු.</p>
                  <p>උදා-:</p>
                  <div className="vocab-grid">
                    <div className="vocab-item"><span>우유</span> <span>( උයු ) ~ කිරි</span></div>
                    <div className="vocab-item"><span>아이</span> <span>( අයි ) ~ ළමයා</span></div>
                    <div className="vocab-item"><span>여우</span> <span>( යොඋ ) ~ නරියා</span></div>
                    <div className="vocab-item"><span>오</span> <span>( ඕ ) ~ අංක 5</span></div>
                    <div className="vocab-item"><span>이</span> <span>( ඉ ) ~ දත් සහ අංක 2</span></div>
                    <div className="vocab-item"><span>이유</span> <span>( ඉයු ) ~ හේතුව</span></div>
                    <div className="vocab-item"><span>오이</span> <span>( ඔඉ ) ~ පිපිඤ්ඤා</span></div>
                    <div className="vocab-item"><span>유아</span> <span>( යුආ ) ~ ළදරුවා</span></div>
                    <div className="vocab-item"><span>외워요</span> <span>( වෙවොයෝ ) ~ කට පාඩම් කරනවා</span></div>
                    <div className="vocab-item"><span>와요</span> <span>( වායෝ ) ~ එනවා</span></div>
                  </div>

                  <h3 className="section-subheading">අපි දැන් කොරියන් හෝඩියේ තියෙන මුලික ව්යංජන ඉගෙන ගනිමු.</h3>
                  <p>මුලික ව්යංජන 14කි. ව්යංජන තනිව උච්චාරණය කළ නොහැක. ව්යංජනයක් ස්වරයක් හා එකට එකතු වී උච්චාරණය කළ හැකිය.</p>

                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>ව්යංජන අක්ෂරය</th>
                          <th>උච්චාරණය (සිංහල)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td className="kr-txt">ㄱ</td><td>ක / ග</td></tr>
                        <tr><td className="kr-txt">ㄴ</td><td>න</td></tr>
                        <tr><td className="kr-txt">ㄷ</td><td>ත / ද</td></tr>
                        <tr><td className="kr-txt">ㄹ</td><td>ල / ර</td></tr>
                        <tr><td className="kr-txt">ㅁ</td><td>ම</td></tr>
                        <tr><td className="kr-txt">ㅂ</td><td>ප / බ</td></tr>
                        <tr><td className="kr-txt">ㅅ</td><td>ස / ෂ</td></tr>
                        <tr><td className="kr-txt">ㅇ</td><td>o</td></tr>
                        <tr><td className="kr-txt">ㅈ</td><td>ච / ජ</td></tr>
                        <tr><td className="kr-txt">ㅊ</td><td>ඡ</td></tr>
                        <tr><td className="kr-txt">ㅋ</td><td>ඛ</td></tr>
                        <tr><td className="kr-txt">ㅌ</td><td>ට / ථ</td></tr>
                        <tr><td className="kr-txt">ㅍ</td><td>ෆ</td></tr>
                        <tr><td className="kr-txt">ㅎ</td><td>හ</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <h3 className="section-subheading">ද්විත්ව ව්යංජන</h3>
                  <p>එක සමාන ව්යංජන අක්ෂර දෙකක් තනි ව්යංජන අක්ෂරයක් ලෙස යෙදෙන අවස්ථාව මෙලෙස හඳුන්වයි.මෙවැනි ද්විත්ව ව්යංජන අක්ෂර 5ක් දක්නට ලැබේ.</p>

                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>ද්විත්ව ව්යංජනය</th>
                          <th>ශබ්දය (සිංහල)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td className="kr-txt">ㄲ</td><td>ක්ක</td></tr>
                        <tr><td className="kr-txt">ㄸ</td><td>ත්ත</td></tr>
                        <tr><td className="kr-txt">ㅃ</td><td>ප්ප</td></tr>
                        <tr><td className="kr-txt">ㅆ</td><td>ස්ස</td></tr>
                        <tr><td className="kr-txt">ㅉ</td><td>ච්ච</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <p>උදා:-</p>
                  <div className="vocab-grid">
                    <div className="vocab-item"><span>가구</span> <span>( කාගු ) ~ ලී බඩු</span></div>
                    <div className="vocab-item"><span>아기</span> <span>( අගි ) ~ බබා</span></div>
                    <div className="vocab-item"><span>나이</span> <span>( නඉ ) ~ වයස</span></div>
                    <div className="vocab-item"><span>누구</span> <span>( නුගු ) ~ කවුද ?</span></div>
                    <div className="vocab-item"><span>다리</span> <span>( තරි ) ~ කකුල /පාලම</span></div>
                    <div className="vocab-item"><span>가다</span> <span>( කදා ) ~ යනවා</span></div>
                    <div className="vocab-item"><span>라디오</span> <span>( ලාදිඕ ) ~ රේඩියෝව</span></div>
                    <div className="vocab-item"><span>나라</span> <span>( නාරා ) ~ රට</span></div>
                    <div className="vocab-item"><span>모기</span> <span>( මෝගි ) ~ මදුරුවා</span></div>
                    <div className="vocab-item"><span>어머니</span> <span>( ඔමොනි ) ~ අම්මා</span></div>
                    <div className="vocab-item"><span>바보</span> <span>( පාබෝ ) ~ මෝඩයා</span></div>
                    <div className="vocab-item"><span>수도</span> <span>( සුදෝ ) ~ අගනුවර</span></div>
                    <div className="vocab-item"><span>쉬다</span> <span>( ස්විදා ) ~ විවේක ගන්නවා</span></div>
                    <div className="vocab-item"><span>주소</span> <span>( චුසෝ ) ~ ලිපිනය</span></div>
                    <div className="vocab-item"><span>자주</span> <span>( චාජු ) ~ නිතරම</span></div>
                    <div className="vocab-item"><span>치마</span> <span>( ඡිමා ) ~ සාය</span></div>
                    <div className="vocab-item"><span>코코아</span> <span>( ඛොඛොආ ) ~ කොකෝවා</span></div>
                    <div className="vocab-item"><span>토마토</span> <span>( තොමාතෝ ) ~ තක්කාලි</span></div>
                    <div className="vocab-item"><span>피아노</span> <span>( ෆිආනෝ ) ~ පියානෝව</span></div>
                    <div className="vocab-item"><span>호수</span> <span>( හෝසු ) ~ වැව /පොකුණ /විල</span></div>
                    <div className="vocab-item"><span>끄다</span> <span>( ක්කදා ) ~ විශාලයි/ලොකුයි</span></div>
                    <div className="vocab-item"><span>이따</span> <span>( ඉත්තා ) ~ ටිකකින්/පසුව</span></div>
                    <div className="vocab-item"><span>오빠</span> <span>( ඔප්පා ) ~ අයියා (ගැහැණු අය අමතන ආකාරය )</span></div>
                    <div className="vocab-item"><span>가짜</span> <span>( කච්චා ) ~ ව්යාජ</span></div>
                  </div>
                </div>
              )}

              {activeTab === 'structures' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">කොරියානු භාෂාවේ ආකාර 4කට අක්ෂර භාවිතයේ යොදනු ලැබේ.</h3>
                  <div className="step-block">
                    <p className="step-item">1) ස්වර ආකාරය</p>
                    <p className="step-item">2) ව්යංජන + ස්වර ආකාරය</p>
                    <p className="step-item">3) ස්වර + ව්යංජන ආකාරය</p>
                    <p className="step-item">4) ව්යංජන + ස්වර + ව්යංජන ආකාරය</p>
                  </div>

                  <div className="ex-block">
                    <h4>1) ස්වර ආකාරය .</h4>
                    <p>මෙම ආකාරයට අනුව ස්වරය අක්ෂරයක් ලෙස “o”ව්යංජන අක්ෂරය සමග වචනයක යෙදෙන අවස්ථාව පහත පරිදි පෙන්වා දිය හැකිය.</p>
                    <p>උදා :-</p>
                    <div className="vocab-grid">
                      <div className="vocab-item"><span>아이</span> <span>~ ( ළමයා )</span></div>
                      <div className="vocab-item"><span>오이</span> <span>~ ( පිපිඥ්ඥ )</span></div>
                      <div className="vocab-item"><span>우유</span> <span>~ ( කිරි )</span></div>
                      <div className="vocab-item"><span>왜요</span> <span>~ ( ඇයි )</span></div>
                    </div>
                  </div>

                  <div className="ex-block">
                    <h4>2) ව්යංජන + ස්වර ආකාරය .</h4>
                    <p>මෙහිදී ව්යංජන අක්ෂරයක් ස්වරයක් සමග එකතු වී වචනයක් ලෙස යෙදෙන ආකාරය පහත පරිදි පෙන්වා දිය හැකිය.</p>
                    <p>උදා:-</p>
                    <div className="vocab-grid">
                      <div className="vocab-item"><span>가구</span> <span>~ ( ලී බඩු )</span></div>
                      <div className="vocab-item"><span>치마</span> <span>~ ( සාය )</span></div>
                      <div className="vocab-item"><span>호수</span> <span>~ ( වැව )</span></div>
                      <div className="vocab-item"><span>시계</span> <span>~ ( ඔරලෝසුව )</span></div>
                    </div>
                  </div>

                  <div className="ex-block">
                    <h4>3) ස්වර + ව්යංජන ආකාරය.</h4>
                    <p>මෙහිදී ස්වර අක්ෂරය සමග ව්යංජන අක්ෂරයක් හල් කිරීමක් ලෙස එකතු වී වචනයක් ලෙස යෙදෙන ආකාරය පහත පරිදී පෙන්වා දිය හැකිය.</p>
                    <p>උදා:-</p>
                    <div className="vocab-grid">
                      <div className="vocab-item"><span>옷</span> <span>~ ( ඇඳුම් )</span></div>
                      <div className="vocab-item"><span>안</span> <span>~ ( ඇතුල )</span></div>
                      <div className="vocab-item"><span>원</span> <span>~ ( වොන් )</span></div>
                      <div className="vocab-item"><span>입</span> <span>~ ( කට )</span></div>
                    </div>
                  </div>

                  <div className="ex-block">
                    <h4>4) ව්යංජන + ස්වර + ව්යංජන ආකාරය .</h4>
                    <p>මෙය ව්යංජන අක්ෂරයට ස්වරයක් එකතු වී නැවත ව්යංජන අක්ෂරයක් හල් කිරීමක් ලෙස යෙදෙන අවස්ථාවයි. එය පහත පරිදි පෙන්වා දිය හැකිය.</p>
                    <p>උදා:-</p>
                    <div className="vocab-grid">
                      <div className="vocab-item"><span>공장</span> <span>~ ( කර්මාන්ත ශාලාව )</span></div>
                      <div className="vocab-item"><span>산</span> <span>~ ( කන්ද )</span></div>
                      <div className="vocab-item"><span>책상</span> <span>~ ( පොත් මේසය )</span></div>
                      <div className="vocab-item"><span>극장</span> <span>~ ( සිනමා ශාලාව )</span></div>
                    </div>
                  </div>

                  <h3 className="section-subheading">받침 - (පත්චිම්) - හල් අකුරු</h3>
                  <p>හල් කිරීම් හෙවත් හල් අකුරු කොරියානු භාෂාවෙන් හදුන්වන්නේ පත්චිම් ලෙසය. ව්යංජනයක් හා ස්වරයක් එකතු වී සෑදෙන ප්රධාන අක්ෂරයට යටින් ව්යංජන අක්ෂරයක් ලියනවිට එය හල් කිරීමක් බවට පත් වේ.</p>
                  
                  <div className="formula-box-styled">
                    <div className="formula-line">එනම් පහත උදාහරණය බලන්න,</div>
                    <div className="formula-line-result">산 - සන් - කන්ද</div>
                  </div>

                  <p>මෙහිදී උඩින් ඇති[사 ( ස )] අකුර ස්වරයක් හා ව්යංජනයක් එකතු වී සැදී ඇති ප්රධාන අක්ෂරය වන අතර සැම විටම යටින් ඇති [ㄴ ( න් )] අකුර හල් අකුරක් හෙවත් හල් කිරීමක් වේ. මෙහිදී මෙම කොරියන් භාෂාවේ සෑම වචනයක්ම ලියන විට හල් අක්ෂරය ම ව්යංජනයට යටින් ලියනු ලබයි. මෙම කොරියානු වචන උච්චාරණය කරනු ලබන්නේ මුලින් ව්යංජනය හා ස්වරය එක් වී සෑදුණු ප්රධාන අක්ෂරය ද පසුව හල් අකුරද පිළිවෙලින් ය.</p>
                  
                  <div className="formula-box-styled">
                    <div className="formula-line">✭ ㅅ + ㅏ + ㄴ = 산</div>
                    <div className="formula-line">✭ ㅈ + ㅣ + ㅂ = 집</div>
                  </div>

                  <p>උදාහරණ-:</p>
                  <div className="vocab-grid">
                    <div className="vocab-item"><span>강</span> <span>= ( කං ) - ගඟ</span></div>
                    <div className="vocab-item"><span>벽</span> <span>= ( ප්යෝක් ) - බිත්තිය / තාප්පය</span></div>
                    <div className="vocab-item"><span>밖</span> <span>= ( පක් ) - පිටත</span></div>
                  </div>
                </div>
              )}

              {activeTab === 'pronunciation' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">උච්චාරණ නීති</h3>
                  <p>කොරියානු භාෂාවේ ඇති ව්යංජන 19 අතුරින් ㄸ, ㅃ, ㅉ යන ද්ව්ත්ව ව්යංජන කිසිවිටක හල් අකුරු ලෙස භාවිතා නොකරයි. ㄲ, ㅆ යන ද්ව්ත්ව ව්යංජන ඇතුළුව සියළු ව්යංජන අක්ෂර හල් කිරීම් ලෙස භාවිතා වෙන නමුත් ඒවා සියල්ල උච්චාරණය වන්නේ ශබ්ද 7කින් පමණි.</p>

                  <div className="table-responsive">
                    <table className="korean-table">
                      <thead>
                        <tr>
                          <th>හල් කිරීම</th>
                          <th>ශබ්දය</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td className="kr-txt">ㄱ,ㅋ,ㄲ</td><td>ක් (ㄱ)</td></tr>
                        <tr><td className="kr-txt">ㄴ</td><td>න් (ㄴ)</td></tr>
                        <tr><td className="kr-txt">ㄷ, ㅅ, ㅆ, ㅈ, ㅊ, ㅌ,ㅎ</td><td>ත් (ㄷ)</td></tr>
                        <tr><td className="kr-txt">ㄹ</td><td>ල් (ㄹ)</td></tr>
                        <tr><td className="kr-txt">ㅁ</td><td>ම් (ㅁ)</td></tr>
                        <tr><td className="kr-txt">ㅂ,ㅍ</td><td>ප් (ㅂ)</td></tr>
                        <tr><td className="kr-txt">ㅇ</td><td>o (ㅇ)</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="ex-block">
                    <p>★ ඇතැම් වචනවල හල් කිරීමක් යෙදී පසුව ස්වරයක් ඇත්නම් එම හල් කිරීම ස්වරය හා එකතු වී උච්චාරණය වන අතර ශබ්දයන් දෙකක් උච්චාරණය වන ව්යංජන අක්ෂරයක් නම් එහි දෙවන ශබ්දයෙන් උච්චාරණය වේ.</p>
                    <p>일일 ( ඉල්ඉල් ) මෙහිදී ㄹ ( ල් ) හල් අකුර ඊට පිටුපස ඇති 이 ( ඉ ) සමඟ එකතු වී 리 ( රි ) අකුර සැදේ. ඉන්පසුව 이릴 යන වචනය උච්චාරණය වේ.</p>
                    <p className="note-text">일일 - (이릴) = ( ඉරිල් ) - පළමුවෙනිදා</p>
                    <p>උදා :-</p>
                    <div className="vocab-grid">
                      <div className="vocab-item"><span>입어요</span> <span>= (이버요) = ( ඉබොයෝ ) = ( අඳිනවා )</span></div>
                      <div className="vocab-item"><span>집ි</span> <span>= (지비) = (චිබි) = ( ගෙදර )</span></div>
                      <div className="vocab-item"><span>손에</span> <span>= (소네) = ( සොනේ ) = ( අතේ )</span></div>
                      <div className="vocab-item"><span>십일</span> <span>= (시빌) = ( සිබිල් ) = ( දින දහයක් )</span></div>
                      <div className="vocab-item"><span>시험은</span> <span>= (시허믄) = (සි හොමන් ) = ( විභාගය )</span></div>
                    </div>
                  </div>

                  <div className="ex-block">
                    <p>එමෙන්ම වචනයක ㄱ ( ක් ), ㄷ ( ත් ), ㅂ ( ප් ) ශබ්දයෙන් උච්චාරණය වන ව්යංජනයක් හල් කිරීමක් ලෙස පැමිණි අවස්ථාවේ දී පසුව යෙදෙන ව්යංජන අක්ෂරය ශබ්දයන් දෙකක් උච්චාරණය වන ව්යංජනයක් නම් එහි පළමු ශබ්දයෙන් උච්චාරණය වන අතර ㄴ( න් ) , ㄹ( ල් ) , ㅁ( ම් ) , ㅇ( o ) යන ව්යංජන අක්ෂර හල් කිරීමක් ලෙස යෙදී පසුව යෙදෙන ව්යංජන අක්ෂරය ශබ්දයන් දෙකක් උච්චාරණය වන අක්ෂරයක් නම් එහි දෙවන ශබ්දයෙන් උච්චාරණය වේ.</p>
                    <p>උදා:-</p>
                    <div className="vocab-grid">
                      <div className="vocab-item"><span>입다</span> <span>= ( ඉප්තා ) = අඳිනවා</span></div>
                      <div className="vocab-item"><span>씻다</span> <span>= ( සිත්තා ) = සෝදනවා</span></div>
                      <div className="vocab-item"><span>식당</span> <span>= ( සික්තං ) = ආපන ශාලාව</span></div>
                      <div className="vocab-item"><span>닫다</span> <span>= ( තත්තා ) = වහනවා</span></div>
                      <div className="vocab-item"><span>안경</span> <span>= ( අන්ග්යොo ) = ඇස් කණ්නාඩි</span></div>
                      <div className="vocab-item"><span>일본</span> <span>= ( ඉල්බොන් ) = ජපානය</span></div>
                      <div className="vocab-item"><span>남동생</span> <span>= ( නම්දොoසෙo ) = මල්ලි</span></div>
                      <div className="vocab-item"><span>공장</span> <span>= ( කොංජo ) = කර්මාන්ත ශාලාව</span></div>
                    </div>
                  </div>

                  <div className="ex-block">
                    <p>★ ඇතැම් වචනයක එකිනෙකට වෙනස් ව්යංජන අක්ෂර 2ක් පත්චිම් ලෙස යෙදී ඇත්නම් හා ඊට ඉදිරියෙන් ඇත්තේ ස්වරයක් නම් හල් කිරීම ලෙස මුලින් ඇති ව්යංජන අක්ෂරය හල් කිරීමක් ලෙසම උච්චාරණය වී පසුව ඇති ව්යංජන අක්ෂරය ඉදිරියේ ඇති ස්වරය සමග එකතු වී උච්චාරණය වේ.</p>
                    <p className="note-text">★ 앉아요➔안 + ㅈ + 아요➔안자요 (මෙය උච්චාරණය පමණි. මෙසේ ලිවිය නොහැක.)</p>
                    <p>උදා:-</p>
                    <div className="vocab-grid">
                      <div className="vocab-item"><span>닭이</span> <span>= ( 달기 ) = ( තල්ගි ) = කුකුළා</span></div>
                      <div className="vocab-item"><span>읽어요</span> <span>= ( 일거요 ) = ( ඉල්ගොයෝ ) = කියවනවා</span></div>
                      <div className="vocab-item"><span>앉아요</span> <span>= ( 안자요 ) = ( අන්ජායෝ ) = වාඩිවෙනවා</span></div>
                      <div className="vocab-item"><span>없어요</span> <span>= ( 업서요 ) = ( ඔප්සොයෝ ) = ඇත්තේ නැත</span></div>
                    </div>
                  </div>

                  <div className="ex-block">
                    <p>★ එසේම වචනයක එකිනෙකට වෙනස් ව්යංජන අක්ෂර 2ක් පත්චිම් ලෙස යෙදී පසුව ව්යංජන අක්ෂරයක් ඇත්නම් එවිට එයින් එක් ව්යංජන අක්ෂරයක් පමණක් උච්චාරණය වේ.</p>
                    <div className="vocab-grid">
                      <div className="vocab-item"><span>읽다</span> <span>~ ( 익따 ) ~ ( ඉක්තා ) ~ කියවනවා</span></div>
                      <div className="vocab-item"><span>닭</span> <span>~ ( 닥 ) ~ ( තක් ) ~ කුකුළා</span></div>
                      <div className="vocab-item"><span>삶다</span> <span>~ ( 삼따 ) ~ ( සම්තා ) ~ තම්බනවා</span></div>
                      <div className="vocab-item"><span>앉다</span> <span>~ ( 안따 ) ~ ( අන්තා ) ~ වාඩිවෙනවා</span></div>
                      <div className="vocab-item"><span>넓다</span> <span>~ ( 널따 ) ~ ( නොල්තා ) ~ පුළුල්</span></div>
                      <div className="vocab-item"><span>싫다</span> <span>~ ( 실따 ) ~ ( සිල්තා ) ~ අකමැතියි</span></div>
                      <div className="vocab-item"><span>없다</span> <span>~ ( 업따 ) ~ ( ඔප්තා ) ~ ඇත්තේ නැත</span></div>
                    </div>
                  </div>

                  <h3 className="section-subheading">කාලය සහ වර්තමාන කාලය</h3>
                  <p>ඒ අනුව සියළු ම අක්ෂර සහ වචන ලිවීමට කියවීමට හුරු වූ අප දැන් අධ්යයනය කළ යුත්තේ කොරියානු භාෂාව කතා කිරීමේදී , ලිවීමේදී භාවිතා කරනු ලබන ක්රමවේදයන් ගැන සළකා බැලීමයි.</p>
                  <p>පළමු ව ලොව සියළු ම භාෂාවන් මෙන් ම කොරියානු භාෂාවේ ද අතීත ( 과거 ), වර්තමාන ( 현재 ), අනාගත ( 미래 ) යනුවෙන් කාල 3 කට බෙදේ.</p>
                  <p>ඒ අනුව සරල වර්තමාන කාලය යටතේ ක්රම 4කට අදහස් ප්රකාශ කිරීම සිදු කෙරේ.</p>
                  
                  <div className="step-block">
                    <p className="step-item" style={{ display: 'flex', alignItems: 'center' }}>
                      <svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor" style={{ color: '#2563eb', marginRight: '10px', flexShrink: 0 }}>
                        <circle cx="12" cy="12" r="8"></circle>
                      </svg>
                      සාමාන්ය ප්රකාශන
                    </p>
                    <p className="step-item" style={{ display: 'flex', alignItems: 'center' }}>
                      <svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor" style={{ color: '#2563eb', marginRight: '10px', flexShrink: 0 }}>
                        <circle cx="12" cy="12" r="8"></circle>
                      </svg>
                      ප්රශ්න කිරීම
                    </p>
                    <p className="step-item" style={{ display: 'flex', alignItems: 'center' }}>
                      <svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor" style={{ color: '#2563eb', marginRight: '10px', flexShrink: 0 }}>
                        <circle cx="12" cy="12" r="8"></circle>
                      </svg>
                      විධානය කිරීම
                    </p>
                    <p className="step-item" style={{ display: 'flex', alignItems: 'center' }}>
                      <svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor" style={{ color: '#2563eb', marginRight: '10px', flexShrink: 0 }}>
                        <circle cx="12" cy="12" r="8"></circle>
                      </svg>
                      යෝජනා කිරීම
                    </p>
                  </div>
                  
                  <p>මේවා ඉදිරි පාඩම්වලදී සාකච්ඡා කරනු ලැබේ.</p>
                </div>
              )}
            </div>

            <div className="news-modal-footer">
              <button className="news-modal-btn" onClick={closePopup}>වසා දමන්න</button>
            </div>
          </div>
        </div>
      )}

      {selectedArticle === 'passport' && (
        <div className="news-modal-overlay" onClick={closePopup}>
          <div className="news-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="news-modal-close" onClick={closePopup}>&times;</button>
            
            <div className="news-modal-header">
              <div className="news-modal-tags">
                <span className="news-tag-category">විශේෂ විස්තර</span>
                <span className="news-tag-date">May 06, 2026</span>
              </div>
              <h2>ගුවන් ගමන් බලපත්‍රය ලබාගැනීම</h2>
              <p className="news-modal-subtitle">ගුවන් ගමන් බලපත්රය යනු කොරියානු විභාගය සඳහා පෙනී සිටින ඔබට නැතිවම බැරි දෙයකි.</p>
            </div>

            <div className="news-modal-tabs">
              <button 
                className={`tab-btn ${activeTab === 'passport_steps' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('passport_steps')}
              >
                අයදුම් කිරීමේ පියවර
              </button>
              <button 
                className={`tab-btn ${activeTab === 'passport_office' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('passport_office')}
              >
                කාර්යාලීය ක්‍රියාපටිපාටිය
              </button>
              <button 
                className={`tab-btn ${activeTab === 'passport_special' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('passport_special')}
              >
                විශේෂ උපදෙස්
              </button>
            </div>

            <div className="news-modal-body">
              {activeTab === 'passport_steps' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">ගුවන් ගමන් බලපත්‍රය ලබාගැනීම</h3>
                  <p>ගුවන් ගමන් බලපත්රය යනු කොරියානු විභාගය සඳහා පෙනී සිටින ඔබට නැතිවම බැරි දෙයකි. මෙහිදී ගුවන් ගමන් බලපත්රයක් නිකුත් කිරීමේදී සලකා බලන කරුණු සහ අත්යවශ්යය තොරතුරු බොහොමයක් පහත විස්තරය තුලින් ඔබට දැනගත හැක.</p>

                  <div className="step-block text-left">
                    <p className="step-item">*මේ සඳහා මුලින්ම ඔබට වලංගු ජයාරූපයක් තිබිය යුතුය. (දිග 45මිමි x පළල 35මිමි)</p>
                    <p className="step-item">*මීලගට ගුවන් ගමන් බලපත්රයක් ලබාගැනීමේදී ඔබට පහත ලියකියවිලි මේ සඳහා අනිවාර්යය වේ. හැඳුම්පත සහ එහි පිටපතක් , උප්පැන්න සහතිකය හා එහි පිටපතක්</p>
                    <p className="step-item">ශ්රී ලංකා ගමන් බලපත්රයක් , ආගමන විගමන දෙපාර්තුමේන්තු හදිසි / හඳුනා ගැනීමේ සහතිකයන් සඳහා වන ඉල්ලුම්පත යන ලියකියවිලි මූලිකව අනිවාර්යය වේ.</p>
                    <p className="step-item">*මීලගට තිබෙන්නේ අයදුම්පත් පිරවීම සඳහා ඇති අයදුම් පතක් ලබාගෙන පිරවීමයි. මෙය ඔබට ඉතා පහසුවෙන් ආගමන හා විගමන දෙපාර්තුමේන්තු වෙබ් පිටුව හරහා ලබා ගැනීමට शक्यताවක් තිබේ. එසේත් නොමැතිනම් ඔබට මේ සඳහා ආගමන විගමන දෙපාර්තමේන්තුවට අයත් ප්රධාන කාර්යාල වලින්ද ලබා ගත හැක. (කුරුණෑගල, මහනුවර මාතර සහ වවුනියාව)</p>
                  </div>

                  <h3 className="section-subheading">අයදුම්පත පිරවිය යුතු නිවැරදි ක්රමවේදය</h3>
                  <p>( සම්පූර්ණ කල යුතු අයදුම්පත පහත ලින්කුව විවෘත කර බාගත කිරීම කල හැකිය. අවශ්ය සියලු තොරතුරු එම අයදුම්පත්ර රූප සටහන් මගින් පෙන්වාදී ඇති අතර මෙහි අංක 1 සිට 20 දක්වා පිරවිය යුතු ආකාරය ගැන නිවැරදි අදහසක් ලබා ගන්න )</p>
                  
                  <div style={{ margin: '20px 0', textAlign: 'center' }}>
                    <a 
                      href="http://www.immigration.gov.lk/web/images/stories/pdf/form/passport/passport_application.pdf" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="download-pdf-btn-styled"
                      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                    >
                      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="meta-icon">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                      </svg>
                      අයදුම්පත බාගත කරන්න (Download PDF)
                    </a>
                  </div>

                  <div className="news-modal-img-container" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <img src={ppBImage} alt="Passport Form View Part 1" className="news-modal-inline-img" />
                    <img src={ppBImage1} alt="Passport Form View Part 2" className="news-modal-inline-img" />
                    <img src={ppBImage2} alt="Passport Form View Part 3" className="news-modal-inline-img" />
                    <img src={ppBImage3} alt="Passport Form View Part 4" className="news-modal-inline-img" />
                  </div>

                  <div className="step-block text-left" style={{ marginTop: '24px' }}>
                    <p className="step-item">• එසේ අයදුම් පත පිරවීමෙන් පසුව ආගමන හා විගමන දෙපාර්තමේන්තුව විසින් අනුමත කරන ලැබූ ජායාරූප ශාලාවකින් ඔබගේ ජායාරූපය හා ඊට අදාළ බිල් අංකය ලබා ගන්න.</p>
                    <p className="step-item">• තවද ඉසුරුපාය ප්රධාන කාර්යාලයෙහි සහ අනෙකුත් අනෙකුත් ප්රාදේශීය ලේකම් කාර්යාලයන් මගින්ද මෙය ඔබට ලබා ගත හැක.</p>
                    <p className="step-item">• ජායාරූපය වලංගු වන්නේ දින 90ක් පමණක් බවත් මතක තබා ගන්න.</p>
                    <p className="step-item">• සියලුම ලියකියවිලි භාර දීම සඳහා දිනයක් හා වේලාවක් කලින් වෙන්කරවා ගැනීමට අවශ්ය නම් 0707101060 / 0707101070 යන දුරකතන අංක සඳහා කතා කරන්න. ( දැනට සාමාන්ය සේවා කාලය කොරෝනා හේතුවෙන් ඇණ හිට තිබුනත් එක්දින සේවාව සඳහා ක්රියාත්මක වනු ඇත. )</p>
                    <p className="step-item">• ලියකියවිලි භාර දීමට මත්තෙන් මේ ආකාරයට එය ගොනු කරගෙන ඇත්දැයි බලන්න. ආගමන විගමන දෙපාර්තුමේන්තුව පිහිටන්නේ සුරුපාය බත්තරමුල්ලේ ය.</p>
                  </div>

                  <div className="vocab-grid" style={{ marginTop: '20px' }}>
                    <div className="vocab-item"><span>අයදුම්පත</span></div>
                    <div className="vocab-item"><span>උප්පැන්න සහතිකය</span></div>
                    <div className="vocab-item"><span>ජාතික හැඳුනුම් පත සහ එහි පිටපත</span></div>
                    <div className="vocab-item"><span>online ජායාරූපයේ පත්රිකාව</span></div>
                  </div>
                </div>
              )}

              {activeTab === 'passport_office' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">ලියකිවිලි භාර දීමේදී ප්රථම මහල ස්ථානීය අනුපිළිවෙල ගැන අවදානය යොමු කරන්න</h3>
                  
                  <div className="step-block text-left">
                    <p className="step-item"><strong>1.</strong> ලියකියවිලි පරීක්ෂා කර අංකයක් සහ Token එකක් ලබා දීම සුදු කරයි.</p>
                    <p className="step-item"><strong>2.</strong> ලියකියවිලි වල අනුපිළිවෙල පරීක්ෂා කරයි.</p>
                    <p className="step-item"><strong>3.</strong> ඔබගේ අංකය කතා කරන තුරු රැඳී සිටින්න.</p>
                    <p className="step-item"><strong>4.</strong> අයදුම්පත සහ අනෙකුත් ලියකියවිලි භාර ගැනීම සිදු කරයි.</p>
                    <p className="step-item"><strong>5.</strong> ඇඟිලි සලකුණු ලබා ගන්න අතර මෙහිදී ඇඟිලි දහයෙම ඇඟිලි සලකුණු ලබා ගනී.</p>
                    <p className="step-item"><strong>6.</strong> බැංකුවට මුදල් ගෙවිය යුතු අතර මෙය එක්දින සේවාව සඳහා නම් රු: 15,000ක මුදලක් සහ සාමාන්ය සේවාව සඳහා රු: 3,500 ක මුදලක් ගෙවිය යුතු වෙයි. වයස 16ට අඩු ළමුන් සඳහා එක් දින සේවාව සඳහා රු: 7,500 ක් මුදලක් සහ සාමාන්ය සේවාව සඳහා රු: 2,500ක මුදලක් ගෙවිය යුතුය.</p>
                  </div>

                  <p className="note-text" style={{ marginTop: '20px', fontWeight: 'bold' }}>
                    ( ලංකා රජයේ තීන්දු තීරණය මත සියලුම ගාස්තු සංශෝධනය විය හැකිය.)
                  </p>
                </div>
              )}

              {activeTab === 'passport_special' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">විශේෂ උපදෙස්</h3>
                  
                  <div className="step-block text-left">
                    <p className="step-item">• භික්ෂූන් වහන්සේලා සඳහා ගමන් බලපත්ර නිකුත් කිරීමේ දී උප්පැන්න සහතිකයේ මුල් පිටපත , ජාතික හැඳුනුම්පත සහ ඡායස්ථිති පිටපත් සමඟ ඉදිරිපත් කල යුතුය.</p>
                    <p className="step-item">• භික්ෂූ සාමණේර සහතිකය හෝ උපසම්පදා සහතිකය , ඡායස්ථිති සහතිකය සමඟ ඉදිරිපත් කිරීම අනිවාර්ය වේ.</p>
                    <p className="step-item">• අයදුම්පත් භාර ගැනීම එක්දින සේවාව හරහා නම් රජයේ දිනවල පෙ:ව 7.00 සිට ප: ව 1.30 දක්වා සිදු කරන අතර සාමාන්ය සේවාව නම් රජයේ දිනවල පෙ:ව 8.00 සිට ප:ව 1.30 දක්වා සිදු කරයි.</p>
                    <p className="step-item">• පුද්ගල ගුවන් ගමන් බලපත්රයක් වලංගු කාල සීමාව අවුරුදු 10ක් වන අතර වයස අවුරුදු 16ට අඩු ළමුන්ගේ ගමන් බලපත්රයක් අවුරුදු 3ක් පමණක් වලංගු වේ.</p>
                    <p className="step-item">• ඉහත සඳහන් සියල්ල සම්පූර්ණ වූ පසු පමණක් ගුවන් ගමන් බලපත්රය ලබාගත හැකිය</p>
                  </div>

                  <div className="phrase-box-styled" style={{ marginTop: '30px' }}>
                    <p className="kr-bold" style={{ fontSize: '1.1rem', marginBottom: '15px', color: '#0f172a' }}>
                      • විශේෂයෙන්ම passport හදන්නට පැමිණෙන ඔයාල දිනයක් සහ වේලාවක් වෙන් කරවා ගැනීමට පහත link එකෙ ඇති පෝරමය පුරවන්න
                    </p>
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                      <a 
                        href="https://eservices.immigration.gov.lk/td" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="passport-booking-btn-styled"
                        style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                      >
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="meta-icon">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        දිනයක් සහ වේලාවක් වෙන් කරවා ගන්න
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="news-modal-footer">
              <button className="news-modal-btn" onClick={closePopup}>වසා දමන්න</button>
            </div>
          </div>
        </div>
      )}

      {selectedArticle === 'language' && (
        <div className="news-modal-overlay" onClick={closePopup}>
          <div className="news-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="news-modal-close" onClick={closePopup}>&times;</button>
            
            <div className="news-modal-header">
              <div className="news-modal-tags">
                <span className="news-tag-category">භාෂා දැනුම</span>
                <span className="news-tag-date">May 06, 2026</span>
              </div>
              <h2>කොරියානු භාෂාව</h2>
              <p className="news-modal-subtitle">කොරියානු භාෂාවේ ඉතිහාසය, අනන්‍යතාවය සහ රැකියා සඳහා එහි වැදගත්කම</p>
            </div>

            <div className="news-modal-tabs">
              <button 
                className={`tab-btn ${activeTab === 'background' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('background')}
              >
                භාෂා පසුබිම
              </button>
              <button 
                className={`tab-btn ${activeTab === 'eps_exam' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('eps_exam')}
              >
                E.P.S - K.L.T විභාගය
              </button>
            </div>

            <div className="news-modal-body">
              {activeTab === 'background' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">කොරියානු භාෂාව සහ එහි පසුබිම</h3>
                  <p>කොරියානු ජාතිකයින් ලිවීමේදීත් කථා කිරීමේදිත් හාවිතා කරන්නේ එකම භාෂාවක් ය. එය ඔවුන්ගේ ජාතික අනන්යතාවය විදහාපාන විශිෂ්ට සාධකයන්ද වේ.</p>
                  <p>කොරියානු භාෂාව මධ්යම ආසියාතික අල්තයික් භාෂා පවුලට අයත්ය. ලියන සහ කථා කරන කොරියානු භාෂාව ශතවර්ෂ ගණනාවක් තිස්සේ චීනයේ දේශපාලන හා සංස්කෘතික බලපෑමට නොමද ව ලක් විය. කොරියානු සහ ජපන් බස ව්යාකරණාත්මක සමානකම් පෙන්නුම් කරන අතර ම මෙම භාෂා දෙකෙහි ම චීන වචන බහුලය.</p>
                  <p>කොරියානු හෝඩිය හන්ගල් නම්න් හැදින් වේ. කොරියානු හෝඩිය 1418 – 1450 දක්වා රජ කළ සේජොං රජතුමාගේ නායකත්වයෙන් යුත් විද්වත් මණ්ඩලයක් මගින් 15 වන සියවසේ බිහි විය.</p>
                  <p>ලෝකයේ පවතින භාෂාවන් අතර කොරියානු භාෂාවට සුවිශේෂි වු ස්ථානයක් හිමි ව ඇත. කොරියානු හෝඩිය හන්ගල් යනුවෙන් හඳුන්වනු ලබන අතර එය අක්ෂර 40 කින් සමන්විත වේ. කොරියානු භාෂාව නිර්මාණය කිරිමේ ගරුත්වය ක්රි.ව.1418-1450 දක්වා වු සමය තුළ රාජ්ය පාලනය කළ සේජෝං නම් රජතුමාට හිමිව අත. ඔහු විසින් බිහිකළ මෙම භාෂාව අද ලෝකයේ බොහෝ රටවල ක්රමයෙන් ව්යාප්ත වෙමින් පවති. අද අපටද එය ඉගෙනීමේ අවශ්යතාවය උද්ගත වී ඇත. මෙම භාෂාව ලොවට දායාද කළ සේජෝං රජතුමාට අපගේ ගරුත්වය හා ප්රණාමය පුද කළ යුතුව ඇත.</p>
                </div>
              )}

              {activeTab === 'eps_exam' && (
                <div className="tab-content anim-fade">
                  <h3 className="section-subheading">දකුණු කොරියාවේ රැකියා සහ EPS-KLT විභාගය</h3>
                  <p>දකුණු කොරියාවේ රැකියා සඳහා යෑමට බලාපොරොත්තු වන රැකියා අපේක්ෂකයෙකු කොරියන් භාෂාව ( 한국 말 ) අනිවාර්යෙන් ඉගෙන ගත යුතුය.</p>
                  
                  <div className="formula-box-styled">
                    <div className="formula-line">★ E.P.S - K.L.T (Employment Permit System - Korean Language Test)</div>
                    <div className="formula-line-result">දකුණු කොරියානු රැකියා ගිවිසුම් ක්‍රමය සඳහා මෙම භාෂා පරීක්ෂණය අනිවාර්යයෙන්ම සමත් විය යුතුය!</div>
                  </div>

                  <p>කොරියානු රැකියා අපේක්ෂා කරන්නෙකු කොරියානු මානව සම්පත් සංවර්ධන අධිකාරිය විසින් පවත්වනු ලබන රැකියා ගිවිසුම් ක්රමයට අදාළ කොරියානු භාෂා පරීක්ෂණය E.P.S - K.L.T අනිවාර්යෙන්ම සමත් විය යුතු බැවිනි.</p>
                </div>
              )}
            </div>

            <div className="news-modal-footer">
              <button className="news-modal-btn" onClick={closePopup}>වසා දමන්න</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
